
const ExperienceOperatorToggle = ({ value, onChange, selectedCount }: {
  value: 'and' | 'or';
  onChange: (op: 'and' | 'or') => void;
  selectedCount: number;
}) => {
  if (selectedCount < 2) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
      <div style={{ display: 'flex', gap: 2, borderRadius: 6, overflow: 'hidden' }}>
        <button
          onClick={() => onChange('and')}
          style={{
            padding: '4px 10px', fontSize: 11, fontWeight: 600, border: 'none', cursor: 'pointer',
            backgroundColor: value === 'and' ? '#38566B' : '#f0f0f0',
            color: value === 'and' ? 'white' : '#666',
          }}
        >ALL</button>
        <button
          onClick={() => onChange('or')}
          style={{
            padding: '4px 10px', fontSize: 11, fontWeight: 600, border: 'none', cursor: 'pointer',
            backgroundColor: value === 'or' ? '#38566B' : '#f0f0f0',
            color: value === 'or' ? 'white' : '#666',
          }}
        >ANY</button>
      </div>
      <span style={{ fontSize: 11, color: '#888' }}>
        {value === 'and'
          ? <>Shows people with experience in <b>all</b> selected</>
          : <>Shows people with experience in <b>any</b> of the selected</>}
      </span>
    </div>
  );
};

export default ExperienceOperatorToggle;
